export default __webpack_public_path__ + "locales/pl/PreparationPortal.json?hash=b7c2c69f28b4d9e0b3b1400a37ef16a1";